'use client';

import { useEffect, useState } from 'react';

import {
  useDeviceCheck,
  useLocalStorageState,
  useInitialModalStatus,
} from '@/shared/hooks';
import { STORAGE_KEY } from '@/shared/constants';
import { AlarmSettingModal } from '@/features/Marketing';
import { convertDateString, notifyToast } from '@/shared/utils';
import { useGetAgreement, usePatchAgreement } from '@/entities/marketing';

const AlarmSettingModalWidget = () => {
  const { isDesktop } = useDeviceCheck();
  const { status } = useInitialModalStatus();
  const [isAlarmSettingModalOpen, setIsAlarmSettingModalOpen] = useState(false);
  const [isShowMarketingModalStorage, setIsShowMarketingModalStorage] =
    useLocalStorageState(STORAGE_KEY.MARKETING, false);

  const { data: isAgreement } = useGetAgreement();
  const { mutateAsync: patchAgreement } = usePatchAgreement();

  useEffect(() => {
    // 1순위 - 한번이라도 노출된 경우, 2순위 - 이미 마케팅 수신 동의한 경우 -> 노출하지 않음
    if (isShowMarketingModalStorage) return;

    if (isAgreement) {
      return setIsShowMarketingModalStorage(true);
    }

    // 온보딩 완료후 모달 노출
    if (status.onboarding === 'COMPLETED') {
      setIsAlarmSettingModalOpen(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status.onboarding, isShowMarketingModalStorage, isAgreement]);

  const onSubmit = async () => {
    toggleAlarmSettingModal();

    const { data } = await patchAgreement({ isAgree: true });

    const date = convertDateString(
      data.data.date_privacy_marketing_consent,
      '(yyyy.mm.dd.)'
    );

    notifyToast({
      type: 'success',
      message: `마케팅 정보 수신 동의가 정상 처리되었습니다. ${date}`,
    });
  };

  const toggleAlarmSettingModal = () => {
    setIsAlarmSettingModalOpen((prev) => {
      if (prev) setIsShowMarketingModalStorage(true);

      return !prev;
    });
  };

  return (
    <AlarmSettingModal
      isDesktop={isDesktop}
      isOpen={isAlarmSettingModalOpen}
      onSubmit={onSubmit}
      onClose={toggleAlarmSettingModal}
    />
  );
};

export default AlarmSettingModalWidget;
